{
  "label": "usuario",
  "button": {
    "delete": "Eliminar el usuario",
    "create": "Nuevo usuario",
    "activate": "Activar el usuario",
    "deactivate": "Desactivar el usuario",
    "disabled": {
      "unauthorized": "Permisos insuficientes para editar este usuario"
    }
  },
  "empty": "No se encontró ningún usuario",
  "confirmRemove": {
    "title": "Eliminación de un usuario",
    "description": "El usuario seleccionado \"{userName} {userFirstname}\" se eliminará"
  },
  "form": {
    "userIdentity": {
      "title": "Información"
    },
    "userProfile": {
      "title": "Perfil"
    },
    "userGroups": {
      "title": "Grupos",
      "selectAllLabel": "Seleccionar todos los grupos"
    },
    "tabs": {
      "information": "Información",
      "delegations": "Delegaciones"
    },
    "delegations": {
      "selectOrganization": "Seleccionar la organización",
      "selectProfile": "Seleccionar el perfil",
      "noProfile": "Sin perfil"
    }
  },
  "search": "Búsqueda por nombre o apellidos",
  "userAccount": {
    "userInformations": {
      "title": "Información del usuario"
    },
    "password": {
      "title": "Contraseña"
    },
    "language": {
      "title": "Idioma",
      "activeDirectoryWarning": "Ya no se puede modificar el idioma debido a que el Active Directory está activado."
    },
    "certificate": {
      "title": "Certificado"
    },
    "instructions": {
      "informations": "Actualice su información personal aquí.",
      "email": "Gestion de correo electronico.",
      "phone": "Añada su número de teléfono.",
      "password": "Actualice su contraseña.",
      "language": "Seleccione el idioma que desea utilizar para LX Connect."
    },
    "forms": {
      "cancel": "Cancelar",
      "certificateEmpty": "Ningún certificado",
      "certificateStatusDateFormat": "DD/MM/YYYY",
      "currentPassword": "Verificación de la contraseña actual",
      "edit": "Editar",
      "email": "E-mail",
      "firstName": "Nombre",
      "generatedOn": "Generado el",
      "lastName": "Apellidos",
      "login": "Acceso",
      "newPassword": "Nueva contraseña",
      "organisationName": "Nombre de la organización",
      "phoneNumber": "Número de teléfono",
      "profile": "Perfil",
      "requestNewCertificate": "Solicitar un nuevo certificado",
      "sectors": "Sectores",
      "validate": "Validar",
      "validFrom": "Válido del",
      "validTo": "Válido hasta el"
    }
  },
  "table": {
    "column": {
      "lastName": "Apellido",
      "firstName": "Nombre de pila",
      "profile": "Perfil",
      "email": "Correo electrónico",
      "groups": "Grupos",
      "status": "Estado"
    }
  },
  "status": {
    "active": "Activo",
    "inactive": "Inactivo"
  },
  "firstNameRequiredError": "El nombre es obligatorio.",
  "lastNameRequiredError": "El apellido es obligatorio.",
  "loginRequiredError": "El nombre de usuario es obligatorio.",
  "emailRequiredError": "El correo electrónico es obligatorio.",
  "languageError": "El idioma es obligatorio.",
  "firstNameLengthError": "Longitud de entre 1 y 50 caracteres.",
  "firstNameFormatError": "Se permiten caracteres especiales excepto al principio o al final --> [ -_.'].",
  "lastNameLengthError": "Longitud de entre 1 y 50 caracteres.",
  "lastNameFormatError": "Se permiten caracteres especiales excepto al principio o al final --> [ -_.'].",
  "loginLengthError": "Longitud de entre 2 y 50 caracteres.",
  "loginFormatError": "Solo en minúsculas. Se permiten caracteres especiales, excepto al principio y al final --> [!$%&'*+=?^`{'{'}{'|'}{'}'}~{'@'}_.-].",
  "emailFormatError": "Formato de correo electrónico no válido.",
  "create": {
    "title": "Creación de usuarios",
    "information": "Información",
    "saveButton": "Crear el usuario",
    "confirm": {
      "title": "Creación de usuarios"
    }
  },
  "lastName": "Apellido",
  "firstName": "Nombre de pila",
  "addUser": {
    "button": "Nuevo usuario"
  },
  "login": "Iniciar sesión",
  "email": "Correo electrónico",
  "language": "Idioma",
  "profile": "Perfil",
  "profilePlaceholder": "Buscar por nombre de perfil",
  "profileRequired": "El perfil es obligatorio.",
  "groups": "Grupos",
  "groupsSearchPlaceholder": "Buscar por nombre de grupo",
  "sectors": "Sectores",
  "update": {
    "title": "Modificar usuario",
    "confirm": {
      "title": "Editar el usuario"
    }
  },
  "confirm": {
    "message": "¿Confirma la cancelación de la operación? Se perderán todos los datos no guardados."
  },
  "filters": {
    "selectionQuickFilters": {
      "allUsers": "Todos los usuarios",
      "selectedUsers": "Usuarios seleccionados",
      "unselectedUsers": "Usuarios no seleccionados"
    }
  },
  "read": {
    "title": "Ver usuario"
  }
}
